module.exports = __webpack_public_path__ + "static/media/log-sys.5fff5997.svg";